import type { AiVideoTags, SafetyOccurrence } from '@cobliteam/common-types';
import Tag from '@cobliteam/ui/components/Tag';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import Typography from '@cobliteam/ui/components/Typography';
import IconSparkles from '@cobliteam/ui-business/components/Icons/IconSparkles';
import { isNoSeatbeltOccurrence } from '@cobliteam/ui-business/utils/mediaUtils';

interface TagSafetyOccurrencesProps {
  safetyOccurrences: SafetyOccurrence[];
  aiVideoTags?: AiVideoTags;
}

const TagSafetyOccurrences = ({ safetyOccurrences, aiVideoTags }: TagSafetyOccurrencesProps) => {
  if (safetyOccurrences.length === 0) {
    return <Typography>-</Typography>;
  }

  const occurrencesWithFrequencies = safetyOccurrences.reduce(
    (accumulator, occurrence) => {
      const found = accumulator[occurrence.id];
      if (!found) {
        accumulator[occurrence.id] = {
          ...occurrence,
          freq: 0,
        };
      }

      accumulator[occurrence.id].freq += 1;
      return accumulator;
    },
    {} as Record<string, SafetyOccurrence & { freq: number }>
  );

  const occurrences = Object.values(occurrencesWithFrequencies).sort((one, other) => other.freq - one.freq);

  return (
    <div className='flex w-full flex-wrap gap-2'>
      {occurrences.map((occurrence) => {
        const count = occurrence.freq > 1 ? `${occurrence.freq} ` : '';

        const isAiTag = Boolean(isNoSeatbeltOccurrence(occurrence) && aiVideoTags?.seatbeltDetection?.withSeatbelt === false);

        return (
          <Tooltip content={isAiTag ? 'Ocorrência sugerida por IA' : undefined} key={occurrence.id} enable={isAiTag}>
            <Tag key={occurrence.id} icon={isAiTag ? <IconSparkles size={12} /> : undefined} label={`${count}${occurrence.name}`} />
          </Tooltip>
        );
      })}
    </div>
  );
};

export default TagSafetyOccurrences;
